/**
 * Shared styles for wizard (Design Constitution: #07070f, #7850ff→#c084fc, border-radius ≥8px).
 */

export const inputStyle: React.CSSProperties = {
  width: '100%',
  background: 'rgba(255,255,255,0.04)',
  border: '1px solid rgba(255,255,255,0.07)',
  borderRadius: 8,
  padding: '8px 10px',
  color: '#f4f0ff',
  fontSize: '0.9375rem',
  fontFamily: 'Onest, sans-serif',
  outline: 'none',
  transition: 'border-color 0.2s',
};

export const inputFocusStyle: React.CSSProperties = {
  borderColor: 'rgba(180,100,255,0.35)',
};

export const textareaStyle: React.CSSProperties = {
  ...inputStyle,
  minHeight: 60,
  resize: 'vertical',
};

export const categoryBtnStyle = (active: boolean): React.CSSProperties => ({
  padding: '8px 12px',
  borderRadius: 8,
  border: `1px solid ${active ? 'rgba(180,100,255,0.35)' : 'rgba(255,255,255,0.07)'}`,
  background: active ? 'rgba(120,80,255,0.15)' : 'rgba(255,255,255,0.04)',
  color: active ? 'var(--accent2, #c084fc)' : 'rgba(255,255,255,0.8)',
  fontSize: '0.8125rem',
  fontWeight: 500,
  cursor: 'pointer',
  transition: 'border-color 0.2s, background 0.2s, color 0.2s',
});

export const btnNextStyle: React.CSSProperties = {
  background: 'linear-gradient(135deg, #7850ff, #c084fc)',
  border: 'none',
  borderRadius: 10,
  color: '#fff',
  fontFamily: 'Unbounded, sans-serif',
  fontSize: '9px',
  fontWeight: 600,
  padding: '12px 20px',
  cursor: 'pointer',
  boxShadow: '0 4px 14px rgba(120,80,255,0.4)',
  transition: 'opacity 0.2s',
};

export const btnBackStyle: React.CSSProperties = {
  background: 'transparent',
  border: '1px solid var(--border, rgba(255,255,255,0.07))',
  borderRadius: 10,
  color: 'var(--muted, rgba(255,255,255,0.28))',
  fontFamily: 'Onest, sans-serif',
  fontSize: '0.875rem',
  padding: '12px 20px',
  cursor: 'pointer',
  transition: 'border-color 0.2s, color 0.2s',
};

export const navOverlayStyle: React.CSSProperties = {
  position: 'fixed' as const,
  bottom: 0,
  left: 0,
  right: 0,
  background: 'linear-gradient(0deg, #090912 65%, transparent)',
  padding: '24px 16px 16px',
  display: 'flex',
  gap: 10,
  justifyContent: 'center',
  alignItems: 'center',
  flexWrap: 'wrap',
  zIndex: 10,
};
